import { useApi } from '../useApi.ts';

const apiCall = useApi('storageForecasting');

async function refreshCachedUser (): Promise<void> {
    await apiCall.get<void>({ endpoint: '/api/RefreshCachedUser' });
}

export const storecastAdminApi = {
    refreshCachedUser,
};
